export default defineNuxtPlugin(() => {
  // Global error handler for unhandled promises
  window.addEventListener('unhandledrejection', (event) => {
    console.error('Unhandled promise rejection:', event.reason)

    // Show user-friendly error message
    const toast = useToast()
    toast.add({
      title: 'Er is een fout opgetreden',
      description: 'Er is een onverwachte fout opgetreden. Vernieuw de pagina en probeer het opnieuw.',
      color: 'error',
    })

    // Prevent the default browser error handling
    event.preventDefault()
  })

  // Global error handler for JavaScript errors
  window.addEventListener('error', (event) => {
    console.error('JavaScript error:', event.error)

    // Only show toast for critical errors, not for minor issues
    if (event.error != null && typeof event.error === 'object' && 'name' in event.error) {
      const error = event.error as { name: string }
      if (error.name !== 'ChunkLoadError') {
        const toast = useToast()
        toast.add({
          title: 'Er is een fout opgetreden',
          description: 'Er is een technische fout opgetreden. Probeer de pagina te vernieuwen.',
          color: 'error',
        })
      }
    }
  })
})
